// extracted by mini-css-extract-plugin
export default {"modal":"storymodal_modal__ikDxd"};